import {
  TSearchPropsApiData,
  TSearchProps,
  TSearchItem,
  TSearchPropsItem,
  TSortPropsItem,
  TSort,
  TFFilterPropsItem,
  TFFilter,
} from "../types/Search.types";

export class SearchApiModel {
  private readonly fields?: TSearchPropsApiData;

  constructor(props: TSearchProps) {
    this.fields = props?.fields?.apiData || null;
  }

  get counter(): number {
    return this.fields?.totalSearchResults || 0;
  }

  get results(): TSearchItem[] {
    return (this.fields?.items ?? []).map(
      ({
        title,
        description,
        link,
        highlight,
        PDFLink,
        PDFSize,
        AttachmentName,
        anchor,
        PDFanchor,
      }: TSearchPropsItem) => ({
        title,
        description,
        link,
        highlight,
        PDFLink,
        PDFSize,
        AttachmentName,
        anchor,
        PDFanchor,
      })
    );
  }

  get Sort(): TSort[] {
    return (this.fields?.Sort ?? []).map(({ Key, Value }: TSortPropsItem) => ({
      Key,
      Value,
    }));
  }

  get filter(): TFFilter[] {
    return (this.fields?.filter ?? [])?.map(({ Key, Value }: TFFilterPropsItem) => ({
      Key,
      Value,
    }));
  }

  get ReadMoreText(): string {
    return this.fields?.ReadMoreText ?? '';
  }
  get Pdflabel(): string {
    return this.fields?.Pdflabel ?? '';
  }
  get AttachmentName(): string {
    return this.fields?.AttachmentName ?? '';
  }
  get PdfIcon(): string {
    return this.fields?.PdfIcon ?? '';
  }
  get Filterlabel(): string {
    return this.fields?.Filterlabel ?? '';
  }
  get Sortlabel(): string {
    return this.fields?.Sortlabel ?? '';
  }
}
